/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2020-03-27 19:19:27
 */

import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store/index'
import '../theme/index.css'
import 'babel-polyfill'
import md5 from 'js-md5'
import moment from 'moment'
Vue.prototype.$moment = moment
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$md5 = md5
export const event = new Vue()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

Vue.directive('enterNumber', {
  inserted: function (el) {
    el.addEventListener('keypress', function (e) {
      e = e || window.event
      let charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode
      let re = /\d/
      if (
        !re.test(String.fromCharCode(charcode)) &&
        charcode > 9 &&
        !e.ctrlKey
      ) {
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js